import { media } from '@gem/call/Removable/packages/permissions/permissions';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const getVideoPermission = async (deviceId?: string, withAlert = true): Promise<boolean> => {
  const hasVideoPermission = await media.getVideoPermission(deviceId);

  if (!hasVideoPermission && withAlert) {
    popupsTasks.showAlert(t('calls_no_camera_permissions'));
  } else if (!hasVideoPermission) {
    return false;
  }

  return true;
};
